import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable, from } from 'rxjs';


import { API } from '../.././core/app-config';
import { FPResponse } from '../../shared/shared.model';
import { User, UserListEntity, VRParticipantsEntity, VideoRoomsEntity, VRUsersEntity, ThumbnailImage } from '../video-chat/video-chat.model';

@Injectable()
export class VideoChatService {


    constructor(private http: Http) { }

    //Wake up Webscocket Server
    wakeUpWSServer(): Observable<any> {
        return this.http.get('http://172.16.1.115/').pipe(map(res => res.json()));
    }

    getUsers(CompanyId: number, LoginId: number, MaxRoleGroup: number, VendorId: number, StartRecord: number, EndRecord: number, SortBy: string, OrderBy: string): Observable<UserListEntity> {
        return this.http.get(API.USER + "/GetAll/" + CompanyId + "/" + LoginId + "/" + MaxRoleGroup + "/" + VendorId + "/?StartRecord=" + StartRecord + '&EndRecord=' + EndRecord + "&SortBy=" + SortBy + "&OrderBy=" + OrderBy).pipe(map(res => {
            var users = <any>res.json();
            return users;
        }));
    }
    getUserThumbnail(companyId: number, entity: any[]): Observable<ThumbnailImage[]> {
        return this.http.put(API.USER + "/GetUserThumbnail/" + companyId, entity).pipe(map(res => res.json()));
    }
    saveUserList(entity: VRParticipantsEntity[]): Observable<FPResponse> {
        return this.http.post(API.DISPATCHBOARD + "/InsertVRParticipant", entity).pipe(map(res => res.json()));
    }
    saveNewRoom(entity: VideoRoomsEntity): Observable<FPResponse> {
        return this.http.post(API.DISPATCHBOARD + "/InsertVideoRoom", entity).pipe(map(res => res.json()));
    }

    getAllParticipants(companyId: number, videoRoomsId: number): Observable<VRUsersEntity[]> {
        return this.http.get(API.DISPATCHBOARD + "/GetAllParticipants/" + companyId + '/' + videoRoomsId).pipe(map(res => res.json()));
    }
}